export default __webpack_public_path__ + "static/media/corneal-test.fd16ed9f.png";